import * as Yup from "yup";

import { schema as contactDetailsSchema } from "@/validations/contact-details";

const ERROR_MESSAGES = {
  password: "Das Passwort muss mindestens fünf Zeichen lang sein.",
};

const schema = Yup.object().shape({
  email: contactDetailsSchema.fields.email,
  password: Yup.string().min(5, ERROR_MESSAGES.password),
});

export { ERROR_MESSAGES, schema };
